import React, { useEffect, useState } from 'react';
import { imageUrl, zeusApp } from '../request/index';
import '../assets/css/bottom.css';
import logo from '../assets/image/logo-white.png';

const EzBottom: React.FC = () => {
    const [lang, setLang] = useState<'zh' | 'en'>('zh');

    useEffect(() => {
        const code = localStorage.getItem('siteLanguage') || 'zh';
        setLang(code === 'en' ? 'en' : 'zh');
    }, []);

    /** ============
     *   文案多语言
     * ============ */
    const text = {
        zh: {
            company: '上海奈尔律师事务所',
            techSupport: '由 SoftwareWorks 提供技术支持',
            copyright: '@2025 上海奈尔律师事务所 版权所有',
            icp: '沪 ICP 备 2025154647 号 -3'
        },
        en: {
            company: 'NEXTOOK Law Firm Shanghai',
            techSupport: 'Technical Support by SoftwareWorks',
            copyright: '@2025 NEXTOOK Law Firm Shanghai. All Rights Reserved.',
            icp: 'Shanghai ICP Filing No. 2025154647-3'
        }
    };

    const t = text[lang];

    return (
        <div className='ezbottompadding'>
            <div className="ezbottom">
                <div className="bottom-header">
                    <div className='logo-image'>
                        <img src={logo} alt="logo" />
                    </div>
                    <div className='bottom-header-right'>{t.company}</div>
                </div>

                <div className='ezbottom-bottom'>
                    <div className='ezbottom-bottom-left'>{t.techSupport}</div>
                    <div className='ezbottom-bottom-right'>
                        <span className='icp-filing'>
                            <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">{t.icp}</a>
                        </span>
                        <span>{t.copyright}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EzBottom;
